const initialVersionState = {
	build: process.env.BUILD_NUM,
	api: process.env.API_VERSION,
};
export function version(state = initialVersionState) {
	return state;
}

export default version;



// WEBPACK FOOTER //
// ./src/reducers/version.js